import { render, staticRenderFns } from "./invoiceNotPaid.vue?vue&type=template&id=36b5f413"
import script from "./invoiceNotPaid.vue?vue&type=script&lang=js"
export * from "./invoiceNotPaid.vue?vue&type=script&lang=js"
import style0 from "./invoiceNotPaid.vue?vue&type=style&index=0&id=36b5f413&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports